/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2PhoneCall from 'DesignSystem/Svgs/Tysiav2PhoneCall/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content/Phones/Content/Phone"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let phoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'phone',
path: 'number',
format: fromFormat.phoneNumberUS,
})
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-5yCzy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2PhoneCall
  viewPath={`${viewPath}/Tysiav2PhoneCall`}
 height={16}
 width={16}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="phone.number"
 format="/Data/format.js phoneNumberUS"
 text={phoneNumberValueData}
/>
</div>
{children}
</React.Fragment>)
}